import UserPage from 'flarum/forum/components/UserPage';
import app from 'flarum/forum/app';
import NotificationList from 'flarum/forum/components/NotificationList';

/**
 * NotificationCenterPage — 通知中心（UserPage 子页面）
 *
 * 路由：/u/{username}/notifications
 * 显示在个人主页右侧内容区，保持左侧导航栏。
 * 复用核心 NotificationList 组件（自带分组、全部已读、删除、滚动加载更多）。
 */
export default class NotificationCenterPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);

    // 加载当前登录用户的通知
    app.notifications.load();

    const username = m.route.param('username') || (app.session.user ? app.session.user.slug() : null);
    if (username) {
      this.loadUser(username);
    }
  }

  content() {
    if (!app.session.user) {
      return (
        <div className="NotificationCenterPage">
          <div className="NotificationCenterPage-error">
            <i className="fas fa-exclamation-triangle" />
            <span>请先登录</span>
          </div>
        </div>
      );
    }

    return (
      <div className="NotificationCenterPage">
        <NotificationList state={app.notifications} />
      </div>
    );
  }
}
